import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { SetIntendsToExportDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useSetIntendsToExportMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(SetIntendsToExportDocument, useCartMutationVariables(cart));
}

/** @deprecated Use {@link useSetIntendsToExportMutation} instead. */
export async function setIntendsToExport(intendsToExportTL: boolean): Promise<CartExtension> {
  const { mutate } = useSetIntendsToExportMutation();
  const result = await mutate({ command: { intendsToExportTL } });
  return result!.data! as CartExtension;
}
